module.exports = __webpack_public_path__ + "static/img/newPriceBtn.117e31b5.png";